// extracted by mini-css-extract-plugin
module.exports = {"periodOptionSoon":"PeriodOptionSoon_periodOptionSoon__2dsU2"};